export default __webpack_public_path__ + "locales/es/DeleteThirdPartyDialog.json?hash=e9bcf3c9aa20011362dddb76e245d918";